import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { AI_WEB_MODULE_CONFIG } from './ai-web.module.config';
import { apiProviders } from './api.provider';
import { conversationWebRepositoryProvider, llmProviderWebRepositoryProvider, messageWebRepositoryProvider, skillWebRepositoryProvider, messageStreamingWebRepositoryProvider, resourceChangesRepositoryProvider, promptTemplateWebRepositoryProvider } from './repositories';
import { MESSAGE_STREAMING_API } from './data-sources/app-sync-graphql';
export var AIWebModule = /*#__PURE__*/function () {
  function AIWebModule() {
    _classCallCheck(this, AIWebModule);
  }

  _createClass(AIWebModule, null, [{
    key: "register",
    value: function register(config) {
      return {
        module: AIWebModule,
        providers: [{
          provide: AI_WEB_MODULE_CONFIG,
          useValue: config
        }].concat(_toConsumableArray(apiProviders), [conversationWebRepositoryProvider, messageWebRepositoryProvider, skillWebRepositoryProvider, promptTemplateWebRepositoryProvider, llmProviderWebRepositoryProvider, messageStreamingWebRepositoryProvider, resourceChangesRepositoryProvider]),
        exports: [AI_WEB_MODULE_CONFIG, conversationWebRepositoryProvider, messageWebRepositoryProvider, skillWebRepositoryProvider, promptTemplateWebRepositoryProvider, llmProviderWebRepositoryProvider, messageStreamingWebRepositoryProvider, resourceChangesRepositoryProvider, MESSAGE_STREAMING_API]
      };
    }
  }]);

  return AIWebModule;
}();